import React from 'react';
import LoansComponent from './components/Loans/LoansSummary';

const LoanManagement = () => (
  <LoansComponent />
  );

export default LoanManagement;
